// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dudw","right":"styles_right__2_MjI"};